module.exports = __webpack_public_path__ + "img/16581243_L.591faad5.png";